export default {
  'monitor.title': '📊 Bảng giám sát Đào COW',
  'monitor.subtitle': 'Số liệu thống kê hoạt động khai thác thời gian thực',
  'monitor.loading': 'Đang tải dữ liệu...',
  'monitor.totalMiners': 'Tổng số Thợ đào',
  'monitor.activeMiners24h': 'Hoạt động (24h)',
  'monitor.walletSuffix': 'ví',
  'monitor.totalCoweMined': 'Tổng COW đã đào',
  'monitor.coweSuffix': 'COW',
  'monitor.successRate': 'Tỷ lệ thành công',
};
